var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph"},[_c('div',{ref:"graph",staticClass:"graph",style:({ height: '100%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }